exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-toolbar-filler{flex:1 1 auto}div.container{height:100%;width:100%}div.content{display:block;height:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./script/app.css
 ** module id = 431
 ** module chunks = 0 1
 **/